// Library Methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Circle from "src/assets/shapes/Circle/Circle";
import Square from "src/assets/shapes/Square/Square";

// Utils
import { getDecimalNum } from "src/utils/number/numberHelper";

// Types
import { ChartSpotType } from "src/services/exams/types";

const TOTAL_SPOTS = 36;

type Superior36ChartLegendType = {
  superior36Spots: Array<ChartSpotType>;
};

const Superior36ChartLegend = ({
  superior36Spots,
}: Superior36ChartLegendType) => {
  const { t } = useTranslation();

  const seenSpots = useMemo(
    () => superior36Spots?.filter((point) => point?.seen),
    [superior36Spots]
  );

  const efficiencyScore = useMemo(() => {
    const seenPercentage = (seenSpots?.length / TOTAL_SPOTS) * 100;

    // return an integer
    if (Number.isInteger(seenPercentage)) return seenPercentage;

    // return a floating point with 2 decimal places
    return getDecimalNum(seenPercentage, 2);
  }, [seenSpots?.length]);

  return (
    <div>
      <Box display="flex" alignItems="center" gap="8px">
        <Circle />
        <Typography fontSize="14px">
          <span style={{ fontWeight: 600 }}>{t("Seen")}:</span>{" "}
          {seenSpots?.length}/{TOTAL_SPOTS}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap="8px">
        <Square />
        <Typography fontSize="14px">
          <span style={{ fontWeight: 600 }}>{t("Not Seen")}:</span>{" "}
          {TOTAL_SPOTS - seenSpots?.length}/{TOTAL_SPOTS}
        </Typography>
      </Box>
      <Box display="flex">
        <Typography fontSize="14px">
          <span style={{ fontWeight: 600 }}>{t("Efficiency Score")}:</span>{" "}
          {efficiencyScore}
        </Typography>
      </Box>
    </div>
  );
};

export default Superior36ChartLegend;
